import { Injectable } from "@angular/core";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";

@Injectable()
export class HttpRequestor {
    constructor(public http: HttpClient) {}

    public getRequest(url: string, headers: HttpHeaders = null, params: HttpParams): Promise<any> {
        if(!headers){
            headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        }
        return this.http.get(url, {headers, params})
            .toPromise()
            .catch(this.handleError);
    }

    public postRequest(url: string, data: any, headers: HttpHeaders = null, params: HttpParams ): Promise<any> {
        if(!headers){
            headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        }
        const body = JSON.stringify(data);

        return this.http.post(url, body, {headers, params})
            .toPromise()
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
};



// WEBPACK FOOTER //
// ./src/app/common/HttpRequestor.ts